export interface PowiadomienieFiltrModel {
  registrationFrom: string;
  registrationTo: string;
  module: string;
  type: string;
  wasSeen: boolean;
  showAll: boolean;
  wasReceived: boolean;
  isConfirmationOfReceive: boolean;
  pageSize: number;
  pageNumber: number;
  orderBy: string;
  isAscending: boolean;
  krs: string;
  name: string;
}

export class PowiadomienieFiltr {
  static readonly filtrKey = 'pow-filtr';
}
